import { Button, Card, CardActions, CardContent, CardMedia, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { ReactComponent as CheckCircleOutline } from '../assets/check2-circle.svg';
import { useLocation, useNavigate } from "react-router-dom";
import { paths } from "../paths";
import useProfileStore, { CustomerRoleName, useRoleStore } from "../store/ProfileStore";
import ReferalOtsClientEnrolmentForm
  from "../components/referral-ots-client-enrolment/referral-ots-client-enrolment-form";
import useEnrollmentStore, { ProtectionPlanName } from "../store/EnrollmentStore";
import { useEffect, useState } from "react";
import { EConsentModal } from "../Common/EConsentModal";
import { TaxIdTheftAlertModal } from "../Common/tax-id-theft/tax-id-theft-alert-modal";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlags } from "../types/featureFlags";
import { userProfileData } from "../Common/profileInfo";
import { GetProfileAlerts } from "../queries/GetProfileAlerts";
import { fetchQuery, formatPhone } from "../functions/misc";
import { TaxReturnNotFilingReferralModal } from "../Common/tax-id-theft/tax-return-not-filiing-referral-modal";
import { TaxReturnNotFilingSubscriberModal } from "../Common/tax-id-theft/tax-return-not-filiing-subscriber-modal";
import { TaxReturnNotFilingModal } from "../Common/tax-id-theft/tax-return-not-filiing-modal";
import { TaxIdTheftConfirmationModal } from "../Common/tax-id-theft/confirmation-modal";
import { clientConfig } from "../awsClientConfig";
import { GetProfile } from "../queries/getProfile";
import { GetPartnerWithoutTaxProfessional } from "../queries/GetPartnerWithoutTaxProfessional";
import { GetOrganization } from "../queries/GetOrganization";
import Footer from "../components/footer";

const TaxShieldEnrollment = () => {

  const navigate = useNavigate();
  const { customerRole } = useRoleStore();
  const { protectionPlanEnrollment, taxPrepEnrollment } = useEnrollmentStore();
  const { eConsent } = useProfileStore();
  const [showConsentModal, setShowContentModal] = useState(false);
  const { state } = useLocation();
  const flagList: FeatureFlags = useFlags();
  const [profileAlerts, setProfileAlerts] = useState<any[]>([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showDisagreeModal, setShowDisagreeModal] = useState(false);
  const [partnerName, setPartnerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [profileData, setProfileData] = useState<any>();


  const fetchTaxIDTheftAlerts = async () => {
    const profileId = await userProfileData();
    const profileAlertsData = await fetchQuery({ ProfileId: profileId }, GetProfileAlerts);
    setProfileAlerts(profileAlertsData?.ProfileAlerts?.sort((alert1: any, alert2: any) => alert1.TaxYear - alert2.TaxYear));
  }

  useEffect(() => {
    if (flagList?.featureTaxIdMonitor) {
      fetchTaxIDTheftAlerts();
      fetchClientName();
    }

    if (protectionPlanEnrollment?.subscriptionStatus
      && customerRole !== CustomerRoleName.TaxReliefGraduatedCustomer
      && protectionPlanEnrollment?.subscriptionPlan !== ProtectionPlanName.Free
      && !isTriggeredFromChangePlan()) {
      navigate(paths.dashboard.taxShield.reports);
    }

  }, [protectionPlanEnrollment, flagList]);

  const isTriggeredFromChangePlan = () => {
    if (state && state.action && state.action === 'changePlan') {
      return true;
    }
    return false;
  }

  const fetchClientName = async () => {
    const profileId = await userProfileData();
    const client = new clientConfig();
    client
      .query({
        query: GetProfile,
        variables: { profileId: profileId },
      })
      .then((res: any) => {
        if (res.data.GetProfile !== null) {
          setProfileData(res.data.GetProfile);
          if (res.data.GetProfile.EnrollmentSource === "Referral") {
            client
              .query({
                query: GetPartnerWithoutTaxProfessional,
                variables: {
                  PartnerId: res.data.GetProfile.PartnerId,
                },
              })
              .then((res: any) => {
                const organizationId = res.data.GetPartner.OrganizationId;

                if (organizationId) {
                  client
                    .query({
                      query: GetOrganization,
                      variables: { organizationId },
                    })
                    .then((res: any) => {
                      setPhoneNumber(
                        formatPhone(res.data.GetOrganization.Phone)
                      );
                      setPartnerName(res.data.GetOrganization.Name);
                    })
                    .catch((error: any) => {
                      console.log(error, "error");
                    });
                }
              });
          }
        }
      })
      .catch((error: any) => {
        console.log(error, "error");
      })
      .finally(() => { });
  };

  const onClickHandler = () => {
    console.log(eConsent);
    if (eConsent) {
      if (isTriggeredFromChangePlan()) {
        navigate(paths.settings.myaccount.changePlanEnrolment);
      } else {
        customerRole === CustomerRoleName.TaxReliefGraduatedCustomer ? navigate(paths.dashboard.graduatedResEnrollment)
          : navigate(paths.dashboard.protectionPlanEnrollment)
      }
    } else {
      setShowContentModal(true);
    }
  }

  const onAgreeHandler = () => {
    setShowContentModal(false);
    customerRole === CustomerRoleName.TaxReliefGraduatedCustomer ? navigate(paths.dashboard.graduatedResEnrollment)
      : navigate(paths.dashboard.protectionPlanEnrollment);
  }

  const onConsentModalCloseHandler = () => {
    setShowContentModal(false);
  }

  const onTaxIdTheftAgreeHandler = (alertId: string) => {
    setProfileAlerts(profileAlerts.map((item: any) => item.ProfileAlertId === alertId ? { ...item, Active: false } : item))
    setShowConfirmModal(true);
  }

  const onTaxIdTheftDisagreeHandler = (alertId: string) => {
    setProfileAlerts(profileAlerts.map((item: any) => item.ProfileAlertId === alertId ? { ...item, Active: false } : item));
    setShowDisagreeModal(true);
  }

  const onConfirmModalCloseHandler = () => {
    setShowConfirmModal(false);
  }

  const onConfirmModalAgreeHandler = () => {
    setShowConfirmModal(false);
    navigate(paths.dashboard.uploadTaxReturn);
  }

  const onActionHandler = (action: string) => {
    setShowDisagreeModal(false);
    if (action === 'get-help') {
      navigate(paths.settings.myaccount.changePlanEnrolment, { state: { from: 'taxIdTheftAlert' } });
    } else if (action === 'speak-with-agent') {
      navigate('/schedule-appointment', { state: { from: 'taxIdTheftAlert' } });
    }
  }
  return (
    <>
      {(customerRole === CustomerRoleName.TaxPrepReferredCustomer || customerRole === CustomerRoleName.NonTaxPrepReferredCustomer || customerRole === CustomerRoleName.TaxReliefGraduatedCustomer ) ? <ReferalOtsClientEnrolmentForm /> :
        <>
          <Card sx={{ width: '100%', height: '90vh', p: 0, m: 0, borderRadius: 0, position: 'relative' }}>
            <CardMedia component="img" src="/assets/BG-SmilingFaces.png" sx={{ position: 'absolute', top: 0, right: 0, bottom: 0 }} />
            <CardContent sx={{ position: 'absolute', backgroundColor: 'transparent', top: 50, left: 5, width: '30%' }}>
              <h1 className="headerTitle">Get Protected.<br />Stay Protected!</h1>
              <Typography variant="body1" sx={{ mt: 3 }}>Get Optima’s best-in-class protection<br />plus <b>Lifetime Audit Defense.*</b></Typography>
              <Typography variant="body2" className="mt-3"> <CheckCircleOutline className="me-1" /> Lifetime Audit Defense*</Typography>
              <Typography variant="body2" className="mt-1"> <CheckCircleOutline className="me-1" /> Professional Tax Preparation Services</Typography>
              <Typography variant="body2" className="mt-1"> <CheckCircleOutline className="me-1" /> Discounted Tax Resolution Services</Typography>
              <Typography variant="body2" className="mt-1"> <CheckCircleOutline className="me-1" /> Tax ID Fraud Remediation</Typography>
              <Typography variant="body2" className="mt-1"> <CheckCircleOutline className="me-1" /> And More!</Typography>
              <CardActions className="ms-0 ps-0">
                <Button className="plan-fill-button mt-3 ms-0" onClick={onClickHandler}>Get Protected <ArrowForward /> </Button>
              </CardActions>
              <Typography className="fs-12px">* Lifetime dependent on being active customer of any Optima Tax Shield Plan.
                Please review Protection Agreement for details and limitations.</Typography>

            </CardContent>

          </Card>
          <Footer />
        </>
      }
      {/*showTaxIdTheftAlert && <TaxIdTheftAlertModal profileData={[]} onAgree={() => {}} onDisagree={() => {}} open={showTaxIdTheftAlert} /> */}
      {showConsentModal && <EConsentModal onAgree={onAgreeHandler} onClose={onConsentModalCloseHandler} open={showConsentModal} />}
      {(profileAlerts && profileAlerts.length > 0) &&
        profileAlerts.map((profileAlert: any) => {
          return <TaxIdTheftAlertModal alertData={profileAlert} onAgree={onTaxIdTheftAgreeHandler} onDisagree={onTaxIdTheftDisagreeHandler} open={profileAlert.Active} />
        })
      }
      {showConfirmModal && <TaxIdTheftConfirmationModal onUploadClick={onConfirmModalAgreeHandler} onClose={onConfirmModalCloseHandler} open={showConfirmModal} />}
      {showDisagreeModal &&
        <>
          {
            profileData?.EnrollmentSource === "Referral" ?
              <TaxReturnNotFilingReferralModal onAction={onActionHandler} partnerName={partnerName} phoneNumber={phoneNumber} open={showDisagreeModal} />
              : <>{(protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName.Standard
                || protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName.Premium
                || protectionPlanEnrollment?.subscriptionPlan === ProtectionPlanName.Professional) ?
                <TaxReturnNotFilingSubscriberModal onAction={onActionHandler} planName={protectionPlanEnrollment?.subscriptionPlan} open={showDisagreeModal} />
                : <TaxReturnNotFilingModal onAction={onActionHandler} open={showDisagreeModal} />}
              </>
          }
        </>
      }

    </>
  )
}

export default TaxShieldEnrollment;

